import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation
import { ERoute } from "@enums";
const IataContext = createContext(undefined);
export const IataProvider = ({ children }) => {
    var _a;
    const location = useLocation();
    const navigate = useNavigate();
    const iataFromUrl = (_a = location.pathname.split("/")[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    const isValidIata = (iata) => {
        return ["OSL", "TRD", "BGO", "SVG"].includes(iata !== null && iata !== void 0 ? iata : "");
    };
    const getInitialIata = () => {
        if (isValidIata(iataFromUrl))
            return iataFromUrl;
        const storedIata = localStorage.getItem("iata");
        if (isValidIata(storedIata))
            return storedIata;
        return "OSL";
    };
    const [currentIata, setCurrentIata] = useState(getInitialIata);
    const buildIataPath = (newIata, currentPath, search, hash) => {
        const pathSegments = currentPath.split("/").filter(Boolean);
        const routeValues = Object.values(ERoute).map((v) => v.toLowerCase().replace("/", ""));
        const firstSegment = pathSegments[0];
        if (firstSegment === "tv") {
            pathSegments[0] = newIata.toLowerCase();
            pathSegments[1] = "tv";
        }
        else if (firstSegment) {
            const isRoute = routeValues.some((v) => v === firstSegment.toLowerCase().replace("/", ""));
            if (isRoute) {
                pathSegments.unshift(newIata.toLowerCase());
            }
            else {
                pathSegments[0] = newIata.toLowerCase();
            }
        }
        else {
            pathSegments[0] = newIata.toLowerCase();
        }
        return "/" + pathSegments.join("/") + search + hash;
    };
    useEffect(() => {
        if (!isValidIata(iataFromUrl)) {
            const fallbackIata = (localStorage.getItem("iata") || "OSL");
            const newPath = buildIataPath(fallbackIata, location.pathname, location.search, location.hash);
            console.log(newPath);
            navigate(newPath, { replace: true });
        }
    }, [iataFromUrl, location.pathname, location.search, location.hash, navigate]);
    const setIata = (iata) => {
        const newPath = buildIataPath(iata, location.pathname, location.search, location.hash);
        setCurrentIata(iata);
        localStorage.setItem("iata", iata.toUpperCase());
        navigate(newPath, { replace: true });
    };
    return (_jsx(IataContext.Provider, { value: { iata: currentIata, iataLowerCase: currentIata.toLowerCase(), setIata }, children: children }));
};
export const useIataContext = () => {
    const context = useContext(IataContext);
    if (!context) {
        throw new Error("useIataContext must be used within a IataProvider");
    }
    return context;
};
